import Hero1 from "../components/Hero1";
import img1 from "../assets/quienesSomos/img1.png";
import HorizontalList from "../components/horizontalList";
import HeroB from "../components/HeroB";
import img2 from "../assets/quienesSomos/img2.png";
import MisionYVision from "../components/quienesSomos/MisionYVision";
import img3 from "../assets/quienesSomos/img3.png";
import Esperar from "../components/valor360/esperar";
import img4 from "../assets/quienesSomos/img4.png";
import HeroC from "../components/heroC";
import img5 from "../assets/quienesSomos/img5.png";
import DavidZamora from "../assets/quienesSomos/David_Zamora.png";
import JulianHerrera from "../assets/quienesSomos/me02.jpg";

function QuienesSomos() {
    return (
        <>
            <Hero1
                imagen={img1}
                titulo="¿Quiénes somos?"
                descripcion="Somos un auxiliar financiero dentro del ecosistema Fintech que busca transformar la forma en que los colombianos gestionan sus productos financieros mediante la centralización de la información en MEU Aliado"
            />
            <HorizontalList
                items={[
                    { label: "Sobre nosotros", targetId: "sobre-nosotros" },
                    { label: "Misión y visión", targetId: "mision-vision" },
                    { label: "Historia", targetId: "historia" },
                    { label: "Socios comerciales", targetId: "socios-comerciales" },
                    { label: "Nuestro equipo", targetId: "nuestro-equipo" },
                ]}
            />
            <section id="sobre-nosotros" className="scroll-mt-24">
                <HeroB
                    titulo="Sobre nosotros"
                    parrafo="Somos un grupo de profesionales provenientes de áreas financieras, informáticas y administrativas, unidos por la convicción de que el acceso a productos financieros en Colombia puede y debe ser más ágil, transparente y centrado en el usuario. Nuestra experiencia combina el conocimiento técnico del sistema financiero colombiano con la capacidad de desarrollo tecnológico aplicado a soluciones reales."
                    imagen={img2}
                />
            </section>
            <section id="mision-vision" className="scroll-mt-24">
                <MisionYVision />
            </section>
            <section id="historia" className="scroll-mt-24">
                <HeroB
                    titulo="Historia"
                    parrafo="Luego de varios años de trabajo en investigación, desarrollo e implementación de soluciones de intermediación financiera, en el año 2025 decidimos formalizar legalmente nuestra operación bajo el nombre de MOU Solutions, con el propósito de consolidarnos como una fintech auxiliar del sistema financiero colombiano.

Nuestro enfoque en finanzas abiertas nos permite actuar como terceros receptores de datos y conectar a los usuarios con entidades financieras. Así modernizamos la experiencia financiera y facilitamos la adquisición de productos, fortaleciendo el ecosistema nacional."
                    imagen={img3}
                    botonTexto="Únete a nuestro equipo"
                    invertir
                />
            </section>
            <section id="socios-comerciales" className="scroll-mt-24">
                <Esperar
                    titulo="Socios comerciales"
                    imagen={img4}
                />
            </section>
            <section id="nuestro-equipo" className="scroll-mt-24">
                <HeroC
                    titulo="Nuestro equipo"
                    imagen={img5}
                    modo="equipo"
                    cards={[
                        { nombre: "David Zamora", rol: "Co-founder, CTO", foto: DavidZamora },
                        { nombre: "Julian Herrera", rol: "Co-founder, CEO", foto: JulianHerrera },
                    ]}
                />
            </section>
        </>
    );
}
export default QuienesSomos;